export const TBL_HEADERS = [
  {
    name: "Drug Class",
    variable: "resultMethod",
  },
  {
    name: "Cal Error Text",
    variable: "testCode",
  },
  {
    name: "Cal Time",
    variable: "orderCode",
  },
  {
    name: "Cal Date",
    variable: "tmitCode",
  },
];
